module.exports = __webpack_public_path__ + "img/ico-research--black.1bcd11e1.svg";